import React from 'react'
import PropTypes from 'prop-types'
import { toKebabCase } from 'utils/stringHelpers'
import { StyledDropdownMenu } from '../component.styles'

export const EditCourseMenu = ({
  canAddInstructor,
  courseInstanceName,
  forwardedRef,
  handleAddInstructorSubmit,
  handleDeleteSubmit,
  handleEditSubmit,
  handleLeaveClassSubmit,
  instance,
  isClassCardMenu,
  isOwner,
}) => (
  <StyledDropdownMenu
    canAddInstructor={canAddInstructor}
    courseInstanceName={courseInstanceName}
    dataTestId={`dropdown-menu-button-${toKebabCase(courseInstanceName)}`}
    handleAddInstructorSubmit={handleAddInstructorSubmit}
    handleDeleteSubmit={handleDeleteSubmit}
    handleEditSubmit={handleEditSubmit}
    handleLeaveClassSubmit={handleLeaveClassSubmit}
    instance={instance}
    isClassCardMenu={isClassCardMenu}
    isOwner={isOwner}
    ref={forwardedRef}
  />
)

EditCourseMenu.propTypes = {
  canAddInstructor: PropTypes.bool,
  courseInstanceName: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  handleAddInstructorSubmit: PropTypes.func,
  handleDeleteSubmit: PropTypes.func.isRequired,
  handleEditSubmit: PropTypes.func.isRequired,
  handleLeaveClassSubmit: PropTypes.func,
  instance: PropTypes.object,
  isClassCardMenu: PropTypes.bool,
  isOwner: PropTypes.bool,
}
